import _regeneratorRuntime from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _objectSpread from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import adminDashboard from "./admin";
import userDashboard from "./user";
import distributorDashboard from "./distributor";
export default {
  name: 'Dashboard',
  components: {
    adminDashboard: adminDashboard,
    userDashboard: userDashboard,
    distributorDashboard: distributorDashboard
  },
  data: function data() {
    return {
      currentRole: '',
      loading: {},
      finishNum: 0
    };
  },
  computed: _objectSpread({}, mapGetters(['roles'])),
  watch: {
    '$route': function $route(to, from) {
      //执行数据更新查询
      if (to.path == '/dashboard') {
        this.loadPage();
      }
    },
    currentRole: function currentRole(value) {
      //console.log(value)
      // if (value == 'userDashboard'){
      //   //console.log(this.$refs.currentDashboard)
      //   if (this.$refs.userDashboard){
      //     this.$refs.userDashboard.loadData()
      //   }  
      // }  
    },
    finishNum: function finishNum(value) {
      //console.log(value)
      if (value == 2) {
        if (this.$store.getters.clientId == 13 || this.$store.getters.clientId == 21) {
          this.currentRole = 'userDashboard';
        } else {
          this.currentRole = 'adminDashboard';
        }
        if (!this.roles.includes('admin') && !this.roles.includes('系统管理员')) {
          // this.currentRole = 'userDashboard'
        }
        this.loading.close();
        this.finishNum = 0;
      }
    }
  },
  created: function created() {
    this.loadPage();
  },
  methods: {
    loadPage: function loadPage() {
      //console.log('load...')
      this.loading = this.$loading({
        lock: true,
        text: this.$t("loading.default"),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var lang = this.$store.getters.language;
      this.finishNum = 0;
      if (!this.$store.getters.tableDataDictionary.tables || this.$store.getters.tableDataDictionary.tables.length == 0 || !this.$store.getters.codeDataDictionary.codes || this.$store.getters.codeDataDictionary.codes.length == 0) {
        this.loadDataDictionary(lang);
      } else {
        this.finishNum = 2;
      }
      //console.log(this.$store.getters.clientId)
    },
    loadDataDictionary: function () {
      var _loadDataDictionary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(lang) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([this.loadTableDD(lang), this.loadCodeDD(lang)]);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadDataDictionary(_x) {
        return _loadDataDictionary.apply(this, arguments);
      }
      return loadDataDictionary;
    }(),
    loadTableDD: function loadTableDD(lang) {
      var _this = this;
      this.$store.dispatch('tableDataDictionary/getTableDataDictionary', lang).then(function () {
        _this.finishNum = _this.finishNum + 1;
        console.log('Load tableDataDictionary success');
      }).catch(function () {
        _this.finishNum = _this.finishNum + 1;
        console.log('Load tableDataDictionary failed');
      });
    },
    loadCodeDD: function loadCodeDD(lang) {
      var _this2 = this;
      this.$store.dispatch('codeDataDictionary/getCodeDataDictionary', lang).then(function () {
        _this2.finishNum = _this2.finishNum + 1;
        console.log('Load codeDataDictionary success');
      }).catch(function () {
        _this2.finishNum = _this2.finishNum + 1;
        console.log('Load codeDataDictionary failed');
      });
    }
  }
};